module.exports = __webpack_public_path__ + "static/media/logo-branca.6cbd046c.svg";